import * as React from 'react';
import PropTypes from 'prop-types';
import {translate} from "react-i18next";
import {Subbar, Title} from "ah-tools";
import {Button, Confirm, Dropdown, Form, Icon, Modal, Popup, Segment} from "semantic-ui-react";
import {Divider, TextField} from "material-ui";
import SectionHeader from "./SectionHeader";
import SortableTree from 'react-sortable-tree';
import {createPartsTree, objToArray} from "../misc/tree-handler";
import {IconButton} from "../extensions";


const MODAL_TYPE_DEFAULT = false;

const CREATE_MODAL_DEFAULT = {
	type: MODAL_TYPE_DEFAULT,
	callback: null
};

const MODAL_CREATE = 'create-modal';
const MODAL_UPDATE = 'update-modal';

const CREATE_DATA = {
	title: '',
	price_netto: 0
};
const DND_TYPE = 'dnd_parts';

const DROP_ASK = 1;
const DROP_NODE = 2;
const DROP_ALL = 4;

const DRAG_SOURCE_COMPLETE = 'left';
const DRAG_SOURCE_ALL = 'right';

const CONFIRM_DELETE_DEFAULT_STATE = null;
const CONFIRM_DROP_DEFAULT_STATE = null;

let DRAG_ACTION_STARTED = false;

const PartContent = ({title, price_netto, active}) => (
	<Subbar>
		<Icon name={'cogs'} circular={true} color={active ? 'red' : 'grey'} inverted={true} />
		<Subbar valign={Subbar.VALIGN_STRETCH} direction={Subbar.DIRECTION_COLUMN}>
			<div style={{
				whiteSpace: 'nowrap',
				overflowX: 'hidden',
				maxWidth: 125,
				textOverflow: 'ellipsis',
			}}>{title}</div>
			<div style={{fontSize: 12, fontWeight: 'normal'}}>€ {price_netto}</div>
		</Subbar>
	</Subbar>
);
PartContent.propTypes = {
	title: PropTypes.string.isRequired,
	price_netto: PropTypes.number.isRequired,
	active: PropTypes.bool
};
PartContent.defaultProps = {
	active: false
};

const ArrowButton = ({name, size, color, attached, disabled, onClick, loading}) => (
	<Button attached={attached} color={color} disabled={disabled || loading} loading={loading} onClick={e => {
		e.stopPropagation();
		onClick(e);
	}}><Icon name={name} size={size} /></Button>
);
ArrowButton.propTypes = {
	name: PropTypes.string.isRequired,
	size: PropTypes.string.isRequired,
	attached: PropTypes.string,
	onClick: PropTypes.func.isRequired,
	color: PropTypes.string,
	disabled: PropTypes.bool,
	loading: PropTypes.bool
};
ArrowButton.defaultProps = {
	color: 'blue',
	disabled: false,
	loading: false
};

const TreeMenu = ({onDelete, isLoading, price, number, onChangeNumber, loadingNumbers, onUpdate}) => (
	<Dropdown loading={isLoading} labeled={false} text={' '} icon={<Icon name={'ellipsis vertical'} color={'black'}/>} direction={'left'} inline={true} pointing={'right'}>
		<Dropdown.Menu>
			<Dropdown.Header style={{textAlign: 'center', position: 'relative'}}>
				<strong style={{textAlign: 'center', display: 'block', fontSize: 16}}>€ {price}</strong>
				<span style={{position: 'absolute', left: 0, top: -14, color: 'black', padding: 12, paddingBottom: number ? 0 : 12, borderRight: '1px solid #dddddd'}}>{number || ' '}</span>
			</Dropdown.Header>
			<Dropdown.Divider/>
			{number && <Dropdown.Item className={'ith-number'}>
				<Subbar align={Subbar.ALIGN_BETWEEN}>
					<ArrowButton loading={loadingNumbers} disabled={number <= 1} onClick={() => onChangeNumber(number - 1, number)} attached={'left'} name={'caret left'} size={'small'}/>
					<span style={{paddingLeft: 15, paddingRight: 14}}>{number}</span>
					<ArrowButton loading={loadingNumbers} onClick={() => onChangeNumber(number + 1, number)} attached={'right'} name={'caret right'} size={'small'}/>
				</Subbar>
				
			</Dropdown.Item>}
			<Dropdown.Item onClick={() => onUpdate()}>Bearbeiten</Dropdown.Item>
			{onDelete && <Dropdown.Item onClick={() => onDelete()}>Löschen</Dropdown.Item>}
		</Dropdown.Menu>
	</Dropdown>
);
TreeMenu.propTypes = {
	onDelete: PropTypes.func,
	isLoading: PropTypes.bool,
	price: PropTypes.number.isRequired,
	number: PropTypes.number,
	onChangeNumber: PropTypes.func.isRequired,
	loadingNumbers: PropTypes.bool,
	onUpdate: PropTypes.func.isRequired
};
TreeMenu.defaultProps = {
	isLoading: false,
	price: 0,
	loadingNumbers: false
};


class PartTreeList extends React.Component {
	static propTypes = {
		onLoad: PropTypes.func,
		onCreate: PropTypes.func,
		isCreating: PropTypes.bool,
		isLoadingList: PropTypes.bool,
		parts: PropTypes.object.isRequired,
		// isDeleting: PropTypes.func,
		onDelete: PropTypes.func,
		tree: PropTypes.array.isRequired,
		onExpand: PropTypes.func.isRequired,
		onChangeChildrenCount: PropTypes.func.isRequired,
		isChangingNumber: PropTypes.func.isRequired,
		onUpdate: PropTypes.func.isRequired,
		isUpdating: PropTypes.func,
		onMove: PropTypes.func.isRequired
	};
	static defaultProps = {
		isCreating: false,
		isLoadingList: false,
		parts: {},
		tree: []
	};
	state = {
		createModal: CREATE_MODAL_DEFAULT,
		createData: CREATE_DATA,
		confirmDelete: CONFIRM_DELETE_DEFAULT_STATE,
		dropType: DROP_ASK,
		dragStarted: false,
		confirmDrop: CONFIRM_DROP_DEFAULT_STATE
	};
	
	changeCreate = (name, value) => this.setState(state => ({
		...state,
		createData: {
			...state.createData,
			[name]: value
		}
	})) || true;
	
	setCreate = ({part_id, title, price_netto}, callback, modal = MODAL_UPDATE) => this.setState(state => ({
		...state,
		createModal: {
			type: modal || state.createModal.type,
			callback
		},
		createData: {
			part_id, title, price_netto
		}
	}));
	
	resetCreate = () => this.setState(state => ({
		...state,
		createData: CREATE_DATA
	}));
	
	setConfirmDelete = (confirmDelete) => this.setState({confirmDelete});
	
	setConfirmDrop = confirmDrop => this.setState({confirmDrop});
	
	setDropType = (dropType = DROP_ASK) => this.setState({dropType});
	
	
	showCreateModal = (callback, modal = MODAL_CREATE) => this.setState(state => ({
		...state,
		createModal: {
			type: modal || state.createModal.type,
			callback
		}
	})) || true;
	
	hideCreateModal = () => this.setState({createModal: CREATE_MODAL_DEFAULT, createData: CREATE_DATA});
	
	render = () => {
		const {onLoad, onCreate, isCreating, isLoadingList, parts, onDelete, onExpand, onChangeChildrenCount, isChangingNumber, onUpdate, isUpdating, onMove} = this.props;
		const { createData: {title: partTitle, price_netto: partPriceNetto}, createModal: {type: createModal, callback: modalCallback}, dropType, confirmDelete, confirmDrop} = this.state;
		
		const partList = objToArray(parts.list).map(part => { delete part.children; delete part.expanded; return part; });
		console.info('expansion before tree', parts.expansion);
		const tree = createPartsTree(parts.list, parts.relations, parts.expansion);
		// const tree = [...partList];
		console.info('Tree:', tree);
		console.info('STATE', this.state.createModal, createModal);
		return (
			<React.Fragment>
				<Subbar align={Subbar.ALIGN_BETWEEN}>
					<Subbar>
						<Title>Teilebaum</Title>
						{onLoad && <IconButton onClick={() => onLoad && onLoad(true)}>
							<Icon name={'refresh'} size={'large'} loading={isLoadingList} />
						</IconButton>}
					</Subbar>
					{/*<span ref={el => iconRef = el} style={{visibility: 'hidden'}}><Icon name={'trash'} size={'large'} color={'black'}  circular={true} style={{transform: 'scale(1.5)'}}/></span>*/}
					<Subbar>
						{onCreate && <Popup
							content={'Neues Teil anlegen'}
							inverted={true}
							position={'left center'}
							trigger={
								<IconButton onClick={() => this.showCreateModal(onCreate)}>
									<Icon name={'plus'} size={'large'} />
								</IconButton>}
						/>}
					</Subbar>
				</Subbar>
				
				<Divider inset={true} style={{marginTop: 10, marginBottom: 10}}/>
				
				
				<div style={{display: 'flex',  height: 'calc(100vh - 170px)'}}>
					<Segment basic style={{width: '65%'}}>
						<SectionHeader>
							Verfügbare Teile
						</SectionHeader>
						<SortableTree
							// getNodeKey={({node: {key}}) => key}
							dndType={DND_TYPE}
							treeData={tree}
							onChange={() => {}}
							canDrop={({nextParent, node, ...props}) => {
								// console.info('-> NETXT PARENT:', nextParent, props);
								return nextParent !== null && nextParent.part_id !== node.part_id;
							}}
							// canDrag={node => node.parent_id || node.children && node.children.length}
							shouldCopyOnOutsideDrop={false}
							generateNodeProps={data => ({
								buttons: [
									data.node.number_of_children ? <span>{data.node.number_of_children} <span className={'ith-number-separator'}/> </span> : null ,
									<TreeMenu
										onUpdate={() => this.setCreate(data.node, onUpdate)}
										onChangeNumber={newNumber => data.node.parent_id && onChangeChildrenCount(data.node.parent_id, data.node.part_id, newNumber)}
										isLoading={isUpdating(data.node)}
										loadingNumbers={isChangingNumber(data.node.parent_id, data.node.part_id)}
										onDelete={() => onDelete(data.node)}
										price={data.node.price_netto}
										number={data.node.number_of_children}
									/>
								],
								// subtitle: <div>€ {data.node.price_netto}</div>
								title: <PartContent title={data.node.title} price_netto={data.node.price_netto} active={true}/>
							})}
							onMoveNode={({node: part, nextParentNode, ...nodeInfo}) => {
								if ( !nextParentNode ) {
									return true;
								}
								const {part_id, parent_id: from, tree} = part;
								// if ( tree === DRAG_SOURCE_COMPLETE ) {
									onMove({
										part_id,
										from: from || null,
										to: nextParentNode ? nextParentNode.part_id : null
									});
								// }
								console.info('Node moved on the left', part_id, from || null, tree, nodeInfo);
							}}
							onDragStateChanged={drag => {
								if (drag.isDragging && !DRAG_ACTION_STARTED ) {
									DRAG_ACTION_STARTED = DRAG_SOURCE_COMPLETE;
									if ( drag.draggedNode ) {
										drag.draggedNode.tree = DRAG_SOURCE_COMPLETE;
									}
								}
								
								if ( DRAG_ACTION_STARTED === DRAG_SOURCE_COMPLETE && !drag.isDragging) {
									DRAG_ACTION_STARTED = false;
								}
							}}
							onVisibilityToggle={({node: part, expanded}) => onExpand(part, expanded)}
						/>
						
					</Segment>
					
					<Segment basic style={{width: '35%'}}>
						<SectionHeader>
							<Subbar align={Subbar.ALIGN_BETWEEN}>
								<span>&nbsp;</span>
								Alle Teile
								<Subbar>
									<label style={{marginRight: 5, color: 'grey', fontSize: 12}}>Drop</label>
									<Button.Group>
										<Popup
											inverted={true}
											content={'Immer nachfragen (Standard)'}
										    position={'top right'}
											trigger={
												<Button
													primary={dropType === DROP_ASK}
													onClick={() => this.setDropType(DROP_ASK)}
													icon
													style={{padding: 5}}>
													<Icon name={'question'} size={'large'}/>
												</Button>
											}/>
										<Popup
											inverted={true}
											content={'Nur gewählter Knoten entfernen'}
											position={'top right'}
											trigger={
												<Button
													primary={dropType === DROP_NODE}
										            onClick={() => this.setDropType(DROP_NODE)}
										            icon
													style={{padding: 5}}>
														<Icon name={'linkify'} npsize={'large'}/>
												</Button>}/>
										}/>
										<Popup
											inverted={true}
											content={'Knoten + alle Unterknoten entfernen'}
											position={'top right'}
											trigger={
												<Button
													primary={dropType === DROP_ALL}
										            onClick={() => this.setDropType(DROP_ALL)}
										            icon style={{padding: 5}}>
														<Icon name={'sitemap'} size={'large'}/>
												</Button>
											}/>
									</Button.Group>
								</Subbar>
							</Subbar>
						</SectionHeader>
						<SortableTree
							onMoveNode={node => {
								// if ( !node.nextPath ) return true;
								const {node:{parent_id, part_id}} = node;
								console.info('NODE ON the RIGHT moved', node);
								if ( node.node.tree !== DRAG_SOURCE_COMPLETE ) return false;
								switch(dropType) {
									case DROP_NODE:
										console.info('Should delete only node');
										if ( parent_id ) {
											onMove({part_id, from: parent_id});
										}
										break;
									case DROP_ALL:
										console.info('Should delete all nodes beneeth this one');
										onMove({part_id, from: parent_id, all_nodes: true});
										break;
									case DROP_ASK:
									default: this.setConfirmDrop(node.node);
								}
							}}
							maxDepth={0}
							dndType={DND_TYPE}
							// getNodeKey={({node: {part_id}}) => `complete-list-${part_id}`}
							treeData={partList}
							onChange={() => console.info('changing data :P')}
							canDrop={({nextParent, node: {tree, parent_id, children}}) => {
								if ( tree !== DRAG_SOURCE_COMPLETE ) return false;
								switch(dropType) {
									case DROP_NODE:
										return Boolean(parent_id);
									case DROP_ALL:
										return Boolean(children && children.length);
									case DROP_ASK:
									default:
										return Boolean(parent_id || (children && children.length));
								}
							}}
							shouldCopyOnOutsideDrop={true}
							onDragStateChanged={drag => {
								if (drag.isDragging && !DRAG_ACTION_STARTED ) {
									DRAG_ACTION_STARTED = DRAG_SOURCE_ALL;
									if ( drag.draggedNode ) {
										drag.draggedNode.tree = DRAG_SOURCE_ALL;
									}
								}
								
								if ( DRAG_ACTION_STARTED === DRAG_SOURCE_ALL && !drag.isDragging) {
									DRAG_ACTION_STARTED = false;
								}
							}}
							generateNodeProps={data => ({
								buttons: [
									<TreeMenu
										onUpdate={() => this.setCreate(data.node, onUpdate)}
										onChangeNumber={() => {}}
										isLoading={isUpdating(data.node)}
										onDelete={() => this.setConfirmDelete(data.node)}
										price={data.node.price_netto}
									/>
								],
								title:
									<PartContent title={data.node.title} price_netto={data.node.price_netto} />
							})}
						/>
					</Segment>
				</div>
				
				
				<Modal size={'tiny'} open={createModal !== MODAL_TYPE_DEFAULT} onClose={() => this.hideCreateModal()}>
					<Modal.Header>{createModal === MODAL_CREATE ? 'Teil anlegen' : `Teil bearbeiten`}</Modal.Header>
					<Modal.Content>
						<Form id={'part-create-form'} name={'part-create-form'} loading={isCreating} onSubmit={() => {
								modalCallback(this.state.createData, () => this.hideCreateModal());
						}}>
							<Form.Field>
								<TextField
									required={true}
									fullWidth={true}
									hintText={'Name des Teils'}
									floatingLabelText={'Name des Teils'}
									value={partTitle}
									onChange={(_, value) => this.changeCreate('title', value)}
								/>
							</Form.Field>
							<Form.Field>
								<Subbar valign={Subbar.VALIGN_END}>
									<Icon name={'euro'} style={{marginBottom: 17}}/>
									<TextField
										required={true}
										fullWidth={true}
										hintText={'Preis'}
										type={'number'}
										min={0}
										step={0.01}
										onChange={(_, value) => this.changeCreate('price_netto', Number(value))}
										floatingLabelText={'Preis'}
										value={partPriceNetto}
									/>
								</Subbar>
							</Form.Field>
						</Form>
					</Modal.Content>
					<Modal.Actions>
						<Button
							loading={isCreating}
							disabled={isCreating}
							onClick={() => this.hideCreateModal()}
						>Abbrechen</Button>
						<Button
							form={'part-create-form'}
							loading={isCreating}
							disabled={isCreating}
							positive={true}
						>{createModal === MODAL_CREATE ? 'Anlegen' : 'Ändern'}</Button>
					</Modal.Actions>
				</Modal>
				<Modal open={confirmDrop !== CONFIRM_DROP_DEFAULT_STATE} onClose={() => this.setConfirmDrop(CONFIRM_DROP_DEFAULT_STATE)}>
					<Modal.Header>
						DropHandling
					</Modal.Header>
					<Modal.Content>
						Durch den Drop in die rechte Spalte wird der Knoten zum Vaterknoten im Linken Baum entfernt.<br /><br />
						<i><strong>Auswahl</strong></i>:<br />
						<p>
							<u>Nur diesen Knoten</u><br />
							Bewirkt das nur dieser Knoten gelöscht wird, dadurch wird er zu einem eigenständigen Rootbaum, falls er sonst keine Väterknoten besitzt.
						</p>
						<p>
							<u>Diesen Knoten + Unterknoten</u><br />
							Der gewählte Knoten und alle Knoten unterhalb dieses Knotens werden entfernt. Alle Unterknoten, die dann keinen Vaterknoten mehr haben, sind dann Rootknoten.
						</p>
						<p>
							<u>Alle Unterknoten</u><br />
							Alle Knoten unterhalb dieses Knotens werden entfernt. Alle Unterknoten, die dann keinen Vaterknoten mehr haben, sind dann Rootknoten.
						</p>
						{/*{confirmDrop && <pre>{JSON.stringify(confirmDrop, null, 4)}</pre>}*/}
					</Modal.Content>
					<Modal.Actions>
						<Subbar align={Subbar.ALIGN_BETWEEN}>
							<Subbar>
								<Button
									onClick={() => this.setConfirmDrop(CONFIRM_DROP_DEFAULT_STATE)}
								>Abbrechen</Button>
							</Subbar>
							<Subbar>
								{confirmDrop  && confirmDrop.parent_id && <Button positive={true} onClick={() => onMove({
									from: confirmDrop.parent_id,
									part_id: confirmDrop.part_id,
									to: null
								}, () =>
									this.setConfirmDrop(CONFIRM_DROP_DEFAULT_STATE)
								)}>Nur diesen Knoten</Button>}
								{confirmDrop && confirmDrop.children && confirmDrop.children.length ? <Button negative={true} onClick={() => onMove({
										from: confirmDrop.parent_id || null,
										part_id: confirmDrop.part_id,
										to: null,
										all_nodes: true
									}, () =>
										this.setConfirmDrop(CONFIRM_DROP_DEFAULT_STATE)
								)}>{confirmDrop.parent_id ? 'Diesen Knoten + ' : 'Alle '}Unterknoten</Button>: null}
							</Subbar>
						</Subbar>
					</Modal.Actions>
				</Modal>
				<Confirm
					content={'Wirklich löschen?'}
					open={confirmDelete !== CONFIRM_DELETE_DEFAULT_STATE}
					cancelButton={<Button loading={confirmDelete ? isUpdating(confirmDelete) : false}>Nein</Button>}
					confirmButton={<Button loading={confirmDelete ? isUpdating(confirmDelete) : false} negative={true}>Ja, löschen</Button>}
					onCancel={() => this.setConfirmDelete(CONFIRM_DELETE_DEFAULT_STATE)}
					onConfirm={() => onDelete(confirmDelete, () => this.setConfirmDelete(CONFIRM_DELETE_DEFAULT_STATE))}
				/>
				{/*<pre>{JSON.stringify(partList, null, 4)}</pre>*/}
			</React.Fragment>
		);
	};
}

export default translate()(PartTreeList);


// WEBPACK FOOTER //
// ./src/components/PartTreeList.js